import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import NewSeason from "./components/NewSeason";
import TopRank from "./components/TopRank";
import Category from "./components/Category";
import Review from "./components/Review";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 cursor-pointer ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="relative min-h-screen w-full overflow-x-hidden bg-background-950">
      <Navbar />
      <main>
        <Hero />
        <NewSeason />
        <TopRank />
        <Category />
        <Review />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}